import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './BannerSlider.scss';

const BannerSlider = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('banner-slider-section');
      if (element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Check if section is 50% visible
        if (rect.top < windowHeight * 0.5 && rect.bottom > windowHeight * 0.5) {
          setIsVisible(true);
        } else if (rect.bottom < -100 || rect.top > windowHeight + 100) {
          // Reset when section is completely out of view
          setIsVisible(false);
        }
      }
    };

    // Check on mount to trigger animation immediately if section is visible
    // Add small delay to ensure DOM is fully rendered
    setTimeout(() => {
      handleScroll();
    }, 100);
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const slides = [
    {
      id: 1,
      image: '/images/banner/slide-1.png',
      title: 'Africa SDG 7 Investment & Progress Tracker',
      subtitle: 'A digital platform to track investments and energy access across Africa.',
      buttonText: 'Learn More'
    },
    {
      id: 2,
      image: '/images/banner/slide-2.png',
      title: 'Africa SDG 7 Investment & Progress Tracker',
      subtitle: 'A digital platform to track investments and energy access across Africa.',
      buttonText: 'Learn More'
    },
    {
      id: 3,
      image: '/images/banner/slide-3.jpg',
      title: 'Africa SDG 7 Investment & Progress Tracker',
      subtitle: 'A digital platform to track investments and energy access across Africa.',
      buttonText: 'Learn More'
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    dotsClass: 'banner-slider-dots',
    adaptiveHeight: false,
    lazyLoad: 'ondemand'
  };

  return (
    <section id="banner-slider-section" className={`banner-slider-section ${isVisible ? 'animate' : ''}`}>
      <Slider {...settings}>
        {slides.map((slide) => (
          <div key={slide.id} className="banner-slide">
            <div className="banner-slide-image">
              <img src={slide.image} alt="Africa Energy Trends homepage banner showing sustainable energy initiatives" />
              <div className="banner-slide-overlay">
                <div className="banner-slide-content">
                  <div className="banner-slide-text">
                    <h1 className="banner-slide-title">{slide.title}</h1>
                    <p className="banner-slide-subtitle">{slide.subtitle}</p>
                    <Link to="/about" className="banner-slide-button">{slide.buttonText}</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default BannerSlider;
